export const isNumber = (value) => {
  return typeof value === "number" && !Number.isNaN(Number(value));
};
